/* eslint-disable jira/integration/test-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/default/button';

import type { ModalAttributes } from '@atlaskit/modal-dialog/types';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const modalConfirmButton = defineMessage({
	id: 'software-board-create.modal.form.actions.modal-confirm-button',
	defaultMessage: 'Create',
	description: 'Text for the modal Confirm Button',
});

const modalCancelButton = defineMessage({
	id: 'software-board-create.modal.form.actions.modal-cancel-button',
	defaultMessage: 'Cancel',
	description: 'Text for the modal Cancel button',
});

export type FormActionsProps = {
	submitting: boolean;
	onClose: ModalAttributes['onClose'];
};

export const FormActions = ({ onClose, submitting }: FormActionsProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={buttonGroupContainerStyles}>
			<ButtonGroup>
				<Button
					appearance="subtle"
					isDisabled={submitting}
					onClick={onClose}
					// eslint-disable-next-line jira/integration/test-id-by-folder-structure
					testId="software-board-create.ui.modal.form.actions.board-create-cancel-button"
				>
					{formatMessage(modalCancelButton)}
				</Button>
				<Button
					appearance="primary"
					type="submit"
					isLoading={submitting}
					// eslint-disable-next-line jira/integration/test-id-by-folder-structure
					testId="software-board-create.ui.modal.form.actions.board-create-confirm-button"
				>
					{formatMessage(modalConfirmButton)}
				</Button>
			</ButtonGroup>
		</Box>
	);
};

const buttonGroupContainerStyles = xcss({
	paddingBottom: 'space.100',
});
